<template>
  <div class="tech-jumbotron flex-1 flex items-center content-center">
    <iframe v-if="quizName && quizHtml" :srcdoc="quizHtml" frameborder="0" width="100%" height="100%"></iframe>
    <div v-else-if="init" class="tech-jumbotron-info">
      HTML not found.
    </div>
  </div>
</template>

<script>
import { getOnlyDocDataQuery } from "@/vendor/database";

export default {
  data() {
    return {
      quizName: null,
      quizHtml: null,
      init: false
    };
  },
  mounted: function() {
    this.$store.commit("closeSidebar");
    this.quizName = this.$route.query.name;
    getOnlyDocDataQuery("application_statuses", "name", this.quizName).then(result => {
      if (result.ok) {
        this.quizHtml = result.data.data.html;
      }
    }).finally(() => {
      this.init = true;
    })
  }
};
</script>
